import { TypographyProps } from '@global-engineering-shared/gweb-material-types';
import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetail/EntityDetail.styles';
import EntityDetailTooltip from 'features/EntityDetails/components/EntityDetails/EntityDetailTooltip';

export const NOT_FOUND_VALUE = 'Not Found';

const showPrevious = (value: string, previousValue?: string | null) => {
  if (previousValue) {
    return previousValue !== value;
  }
  return false;
};

interface IEntityDetailValueProps {
  label: string;
  value: string | null;
  previousValue?: string | null;
  isBold?: boolean;
  variant: TypographyProps['variant'];
}

const EntityDetailValue = ({
  label,
  value,
  previousValue,
  isBold = true,
  variant,
}: IEntityDetailValueProps) => {
  const classes = useStyles();
  const displayValue = value || NOT_FOUND_VALUE;
  const shouldShowPrevious = showPrevious(displayValue, previousValue);
  const valueClassName =
    displayValue === NOT_FOUND_VALUE
      ? classes.notFoundValue
      : shouldShowPrevious
        ? classes.changedValue
        : undefined;
  return (
    <Typography variant={variant} className={valueClassName} fontWeight={isBold && 600}>
      <Box className={classes.content}>
        {displayValue}
        {previousValue && shouldShowPrevious && (
          <EntityDetailTooltip
            previousEntityLabel={`Previous ${label}`}
            previousEntityValue={previousValue}
          />
        )}
      </Box>
    </Typography>
  );
};

export default EntityDetailValue;
